import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorProductItemSearch = () => {
  const productSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/product-item/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
      loading(false)
    })
  }, [])
  return { productSearch }
}

export default InteractorProductItemSearch
